import { lazy } from 'react';

export const AsyncAiPageContainer = lazy(() => import(
  /* webpackChunkName: 'ai_page' */
  './AiPageContainer'
));
